import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBidsRoutine } from 'state/bid/bid.routines';

import { bidsSelector } from 'state/bid/bid.selectors';

const useBids = () => {
    const dispatch = useDispatch();
    const { bids } = useSelector(bidsSelector);

    const getBidsForProperty = ({ property }) => {
        if (!bids || bids.length === 0) return [];
        return bids.filter(({ parcelNumber }) => parcelNumber === property.parcelNumber);
    };
    const getMaxBidForProperty = ({ property }) => {
        const propertyBids = getBidsForProperty({ property });
        if (!propertyBids || propertyBids.length === 0) return property.startingBid;
        return propertyBids.sort((a, b) => a - b)[0];
    };

    useEffect(() => {
        if (dispatch) dispatch(getBidsRoutine.trigger());
    }, [dispatch]);

    return {
        bids,
        getBidsForProperty,
        getMaxBidForProperty
    };
};

export default useBids;
